import { ProductState } from "@/cms/sanity.types";

export type PriceList = Omit<
  NonNullable<ProductState["priceLists"]>[number],
  "_key" | "_type"
>;

export type Price = { current: number | null; previous: number | null };

export type PriceTypes = "single" | "per book" | "yearly" | "initial";

export function getPriceSuffix(type?: PriceTypes) {
  switch (type) {
    case "initial":
      return "for første utsendelse";
    case "yearly":
      return "per år";
    case "per book":
      return "per bok";
    default:
      return null;
  }
}

export function formatPrice(
  price?: number | null,
  type: PriceTypes = "single",
) {
  if (typeof price !== "number") return "-";
  if (Number.isNaN(price)) return "";
  if (!Number.isInteger(price)) return price.toFixed(2).replaceAll(/\./g, ",");
  return [`${price},-`, getPriceSuffix(type)].filter(Boolean).join(" ");
}

export function getPriceOffer({
  originalItemPrice,
  priceLists,
  total,
  quantity = 1,
}: {
  originalItemPrice?: number | null;
  quantity?: number;
  total?: number | null;
  priceLists?: PriceList[] | null;
}): Price {
  if (!originalItemPrice) return { current: null, previous: null };
  const originalItemTotal = originalItemPrice * quantity;

  if (total || total === 0)
    return {
      current: total,
      previous: total < originalItemTotal ? originalItemTotal : null,
    };

  const offerItemPrice = priceLists
    ? Math.min(...priceLists.map<number>(({ price }) => price ?? Infinity))
    : null;
  const offerTotal = offerItemPrice ? offerItemPrice * quantity : null;

  if (offerTotal && offerTotal < originalItemTotal)
    return {
      current: offerTotal,
      previous: originalItemTotal,
    };

  return { current: originalItemTotal, previous: null };
}
